import { render, staticRenderFns } from "./StockWarehouse.vue?vue&type=template&id=10fdcc7a&"
import script from "./StockWarehouse.vue?vue&type=script&lang=js&"
export * from "./StockWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports